export function registerInitialInstrumentations(faro) {
    faro.instrumentations.add(...faro.config.instrumentations);
}
